import { IProductList } from 'models/ProductlistPageModel';
import { useSelector } from 'react-redux';
import { chunks, withCurrentPage } from 'utils';
import { getProductList, getProductsPerPage, getPageNumber } from './selectors';

const splitProductsPerPage = ({
  products,
  productsPerPage,
  pageNbr
}: Pick<IProductList, 'products' | 'productsPerPage' | 'pageNbr'>) => {
  const pages = chunks(products, productsPerPage);
  const firstPage = pageNbr - pages.length + 1;

  return pages.map((products, i) => ({ page: firstPage + i, products }));
};

export const useProductlist = () => {
  const products = useSelector(withCurrentPage(getProductList));
  const productsPerPage = useSelector(withCurrentPage(getProductsPerPage));
  const pageNbr = useSelector(withCurrentPage(getPageNumber));
  const pages = splitProductsPerPage({ products, productsPerPage, pageNbr });

  return {
    products,
    pages,
    pageNbr
  };
};
